export const API_SERVICE_EXAMPLE = '/service/v1/example'
export const API_PAYMENT_CHECKOUT_UPDATE = '/payment/v3/transactions'
export const API_GOPAY_CANCEL = '/payment/v1/transactions/gopay/cancel'
export const API_PAYMENT_METHODS = '/payment/v1/methods'
export const API_GET_TOKEN = '/payment/v1/checkout'
export const API_GET_VOUCHERS = '/payment/v1/vouchers'

export const API_GET_SELF = '/member/v1/gs/auth/self'
